/*================ Polyfill =============*/
Array.prototype.contains = Array.prototype.contains || function(obj) {
  return this.indexOf(obj) !== -1;
}
if (!Array.isArray) {
  Array.isArray = function(arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
  };
}

//Fixes a bug with Android not having the :checked pseudoclass, also helps us a bit with styling our checkboxes...
$(document).on('change', 'input[type="checkbox"]', function(e) {
  var self = $(this);
  var parent = self.parent();
  var isChecked = self.prop('checked');

  if(parent.hasClass('checkbox')) {
    if(isChecked) {
      parent.addClass('checked');
    } else {
      parent.removeClass('checked');
    }
  }

  if(isChecked) {
    self.addClass('checked');
  } else {
    self.removeClass('checked');
  }
})
Date.prototype.isValidDate || (Date.prototype.isValidDate = function() {
  if (Object.prototype.toString.call(this) === "[object Date]" ) {
    if(isNaN(this.getTime())) {
      return false;
    } else {
      return true;
    }
  }
  return false;
});
Object.assign = Object.assign || function(t,j) {
  if(!j) return t;
  for(var key in j) {
    t[key] = j[key]
  }
  return t;
}
String.prototype.includes = String.prototype.includes || function(search, start) {
  'use strict';
  if (typeof start !== 'number') {
    start = 0;
  }

  if (start + search.length > this.length) {
    return false;
  } else {
    return this.indexOf(search, start) !== -1;
  }
}

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(search, pos) {
    return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
  };
}

if(!String.prototype.escapeHTML) {
  String.prototype.escapeHTML = function() {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(this));
    return div.innerHTML;
  };
}

if(!String.prototype.handleize) {
  String.prototype.handleize = function () {
    var str = this.toLowerCase();
    var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];

    // For the old browsers
    for (var i = 0; i < toReplace.length; ++i) {
      str = str.replace(toReplace[i], "");
    }

    str = str.replace(/\W+/g, "-");

    if (str.charAt(str.length - 1) == "-") {
      str = str.replace(/-+\z/, "");
    }

    if (str.charAt(0) == "-") {
      str = str.replace(/\A-+/, "");
    }

    return str
  };
}


if (!String.prototype.endsWith) {
  String.prototype.endsWith = function(search, this_len) {
    if (this_len === undefined || this_len > this.length) {
      this_len = this.length;
    }
    return this.substring(this_len - search.length, this_len) === search;
  };
}
window.getDevicePixelRatio = function () {
  var ratio = 1;
  if (window.screen.systemXDPI !== undefined && window.screen.logicalXDPI !== undefined && window.screen.systemXDPI > window.screen.logicalXDPI) {
    ratio = window.screen.systemXDPI / window.screen.logicalXDPI;
  } else if (window.devicePixelRatio !== undefined) {
    ratio = window.devicePixelRatio;
  }
  return ratio;
};


/*================ Tools ================*/
/*
 *  Cart
 *    Contains common Cart related functionality and tools, including an
 *    internally managed cart.
 *
 *  Dependencies:
 *    Ensure that window.Cart.data has been injected by liquid using
 *    window.Cart.data = window.Cart.data || {{ cart | json }};
 *
 *  Version:
 *    1.0.0 - 2018/07/30
 */
window.Cart = window.Cart || {};

//Queue for Cart updates
window.Cart.queue = window.Cart.queue || [];
window.Cart.triggers = window.Cart.triggers || []; //Triggers to fire after cart update.



//Add
window.Cart.add = window.Cart.add || (function(variant, qty, callback, properties) {
  if (typeof qty === typeof undefined) qty = 1;
  var startQueue = window.Cart.queue.length === 0;

  //Setup our tracking object
  var o = {
    variant: variant,
    quantity: qty,
    callback: callback,
    task: 'add',
    data: {
      id: variant,
      quantity: qty,
      properties: properties
    }
  };

  //Create our fake callback
  o.success = function(data) {
    window.Cart.nextItem();
    if (typeof this.callback === "function") this.callback(undefined, data);
  }.bind(o);

  o.error = function(e, i) {
    console.log(e);
    if(e.responseJSON.status == 422){
      alert(e.responseJSON.description);
    }
    if(typeof this.callback === "function") this.callback(e);
    window.Cart.queue = [];
    $(document).trigger('onCartFinished');
  }.bind(o);

  //Add to the queue
  window.Cart.queue.push(o);
  if (startQueue) window.Cart.nextItem();
});


//Remove
window.Cart.remove = window.Cart.remove || (function(index, callback) {
  var startQueue = window.Cart.queue.length === 0;
  var o = {
    index: index,
    callback: callback,
    task: 'remove',
    data: {
      line: index,
      quantity: 0
    }
  };

  o.success = function(data) {
    window.Cart.nextItem();
    if(typeof this.callback === "function") this.callback(undefined, data);
  }.bind(o);

  o.error = function(e, i) {
    console.log(e);
    if(typeof this.callback === "function") this.callback(e);
    window.Cart.queue = [];
    $(document).trigger('onCartFinished');
  }

  window.Cart.queue.push(o);
  if(startQueue) window.Cart.nextItem();
});

//Update
window.Cart.update = window.Cart.update || (function(index, quantity, callback) {
  if(typeof quantity === typeof undefined) return;
  var startQueue = window.Cart.queue.length === 0;
  var o = {
    index: index,
    callback: callback,
    task: 'update',
    data: {
      line: index,
      quantity: quantity
    }
  };

  o.success = function(data) {
    window.Cart.nextItem();
    if(typeof this.callback === "function") this.callback(undefined, data);
  }.bind(o);

  o.error = function(e, i) {
    console.log(e);
    if(typeof this.callback === "function") this.callback(e);
    window.Cart.queue = [];
    $(document).trigger('onCartFinished');
  }

  window.Cart.queue.push(o);
  if(startQueue) window.Cart.nextItem();
});





//Queue Management
window.Cart.nextItem = window.Cart.nextItem || (function() {
  if (!window.Cart.queue.length) {

    //Fire pending triggers
    for (var i = 0; i < window.Cart.triggers.length; i++) {
      var t = window.Cart.triggers[i];
      if (t == 'add') {
        $(document).trigger('onCartAdded');
      } else if(t == 'remove') {
        $(document).trigger('onCartRemoved');
      } else if(t == 'update') {
        $(document).trigger('onCartQuantityUpdated');
      }
    }

    window.Cart.triggers = [];
    $(document).trigger('onCartFinished');
    return;
  }

  //Hint we're doing something with the cart.
  $(document).trigger('onCartPending');

  //Fetch the next task
  var item = window.Cart.queue.shift();

  //Switch
  if (item.task == 'add') {
    if (window.Cart.triggers.indexOf("add") === -1) {
      window.Cart.triggers.push('add');
    }

    $.ajax({
      url: '/cart/add.js',
      method: "POST",
      dataType: "json",
      data: item.data,
      success: item.success,
      error: item.error
    });
  } else if(item.task == 'remove' || item.task == 'update') {
    if(item.task == 'remove' && window.Cart.triggers.indexOf('remove') !== -1) {
      window.Cart.triggers.push('remove');
    } else if(item.task == 'update' && window.Cart.triggers.indexOf('update') !== -1) {
      window.Cart.triggers.push('update');
    }

    $.ajax({
      url: '/cart/change.js',
      method: 'POST',
      dataType: "json",
      data: item.data,
      success: item.success,
      error: item.error
    });
  } else if (item.task == 'get') {
    $.ajax({
      url: '/cart.js',
      method: "GET",
      dataType: "json",
      success: item.success,
      error: item.error
    });
  }

  //All Done, if this has been a cart modification we're going to refetch
  //the cart to see if we have all the latest cart information that we need.
  if (item.task != 'get') {
    window.Cart.queue.push({
      task: 'get',
      success: window.Cart.onCartData,
      error: window.Cart.onCartError
    });
  }
});




window.Cart.onCartData = function(e) {
  //Semi Validate Cart
  if (typeof e === typeof undefined || typeof e.token === typeof undefined) {
    return window.Cart.onCartError(e);
  }

  //Cart is valid, first set it onto the global cart object
  window.Cart.data = e;

  //Now fire an event saying we received a cart update
  $(document).trigger('onCartUpdate', e);
  window.Cart.nextItem();
}

window.Cart.onCartError = function(a, b, c, d) {
  if (a) console.error(a);
  if (b) console.error(b);
  if (c) console.error(c);
  if (d) console.error(d);
  $(document).trigger('onCartFinished');
}

/*
 *  Currency
 *    Tools used for various currency/money related things
 *
 *  Dependencies:
 *    Recommended that window.Currency.format is set from your layout's .liquid file
 *    and injected into the window.Currency.format object
 *
 *    I also recommend window.Currency.currency is set from the layout's .liquid file
 *    as well.
 *
 *  Version:
 *    1.0.0 - 2018/02/09
 */
window.Currency = window.Currency || {};

/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */
window.Currency.formatMoney = function(cents, format) {
  if (typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents, format);
  }
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || '${{amount}}';

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) { return 0; }
    number = (number/100.0).toFixed(precision);
    var parts   = number.split('.'),
    dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
    cents   = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }
  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;

    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;

    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;

    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
}

//Simple hook, this can allow for complex and custom money formatting.
window.Currency.getMoney = function(money) {
  return money;
};
/*
 *  Geo Tools
 *    Provides common tools and funcitons for geo related items, including
 *    callbacks etc.
 *
 *  Dependencies:
 *    js-cookie - Cookies is used to cache data.
 *
 *  Version:
 *    1.0.0 - 2018/09/20
 */

var GEO_CACHE_COOKIE_NAME = 'GeoDataCache';

function geoTools() {
  this.callbacks = [];

  //Check the cookie first and then we can start tracking geodata.
  if(typeof Cookies !== typeof undefined && typeof Cookies.get === "function") {
    var data = Cookies.get(GEO_CACHE_COOKIE_NAME);

    //Cookie may store it as a JSON object... test.
    if(typeof data === "string") {
      try {
        data = JSON.parse(data);
      } catch(e) {
        console.error(e);
        return;
      }
    }

    this.geoData = data;
  }
}

geoTools.prototype = {
  fetchGeo: function(callback) {
    //First let's check if we already have the geo data
    if(typeof this.geoData !== typeof undefined) {
      return callback(this.geoData);//Immediately callback
    }

    //We don't have it, let's fetch and append the callback
    this.callbacks.push(callback);

    //Are we already fetching?
    if(typeof this.geoFetch !== typeof undefined) return;

    //Not fetching, fetch!
    $.ajax({
      url: 'https://ipapi.co/json/?key=6ca9d13b180b0bfaf5e856f65c9d96567bd066e8',
      method: 'GET',
      contentType: 'application/json',
      success: this.onGeoFetched.bind(this),
      error: this.onGeoError.bind(this)
    });
  },

  onGeoError: function(e) {
    console.log(e);
  },

  onGeoFetched: function(data) {
    //Geo fetched
    this.geoData = data;
    for(var i = 0; i < this.callbacks.length; i++) {
      //Fire callback
      this.callbacks[i](data);
    }

    //Fire event
    $(document).trigger('onGeo', data);

    //Store the cookie
    if(typeof Cookies !== typeof undefined && typeof Cookies.set === "function") {
      Cookies.set(GEO_CACHE_COOKIE_NAME, data, { expires: 1 });
    }
  }
};

window.Geo = new geoTools();

/*
 *  Image Tools
 *    Provides a simple Javascript alternative to the tool.picture snippet, as
 *    well as some nice Shopify Image tools for use in Javascript
 *
 *  Version:
 *    1.0.0 - 2018/07/30
 */
window.ImageTools = window.ImageTools || {};

window.ImageTools.getImageURL = window.ImageTools.getImageURL || (function(src,size) {
  size = "" + size;
  if(!size.endsWith("x")) size += "x";

  var removeProtocol = function(path) {
    return path.replace(/http(s)?:/, '');
  };

  if (size === null) {
    return src;
  }
  if (size === 'master') {
    return removeProtocol(src);
  }

  var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

  if (match) {
    var prefix = src.split(match[0]);
    var suffix = match[0];

    return removeProtocol(prefix[0] + '_' + size + suffix);
  } else {
    return null;
  }
});

window.ImageTools.generatePicture = window.ImageTools.generatePicture || (function(image, width, sizes, clazz, alt) {
  if(typeof width === typeof undefined || !width) width = 1400;
  if(typeof sizes === typeof undefined || !sizes || !sizes.length) sizes =  [500, 750, 1000];
  if(typeof alt === typeof undefined || !alt) alt = null;

  var ratios = [1, 2, 4];

  //TODO: Maybe we can enable some way of fetching the information about the
  //image here. (Mainly the image src, alt and dimensions if we can)
  var x = '<picture>';
  for(var i = 0; i < sizes.length; i++) {
    var s = sizes[i];
    x += '<source media="(';
    if(i != (sizes.length-1)) {
      x += 'max-width';
    } else {
      x += 'min-width';
    }

    x += ':'+s+'px)" srcset="';
    for(var y = 0; y < ratios.length; y++) {
      var r = ratios[y];
      x += window.ImageTools.getImageURL(image, s * r);
      if(r != 1) x += ' ' + r + 'x';
      if(y < (ratios.length-1)) y += ', ';
    }
    x += '" '
    if(alt) x += 'alt="'+alt+'" '
    x += '/>'
  }

  x += '<img src="'+window.ImageTools.getImageURL(image, width)+'" ';
  if(alt) x += 'alt="'+alt+'" ';
  if(clazz) x += 'class="'+clazz+'" ';
  x += '/>';
  x += '</picture>';
  return x;
});

/*
 *  Language
 *    Tools for Language options in Javascript
 *
 *  Dependencies:
 *    Add any used language keys to the widnow.Language.strings object.
 *
 *    I'm still toying with the idea of changing languages on the fly, I will look into this.
 *
 *  Version:
 *    1.0.0 - 2018/02/22
 */
window.Language = window.Language || {};
window.Language.strings = window.Language.strings || {};

//Mark a certain string as required, will display a handy debugging alert if it's not
window.Language.required = window.Language.required || (
  function(x) {
    if(typeof window.Language.strings[x] !== typeof undefined) return;
    $(document.body).prepend('<div style="position:fixed;top:0;left:0;background:red;color:white;z-index:9999999">Missing translation key ' + x + '</div>');//Temporarily disabled until I can think of a better solution
  }
);

window.Language.get = window.Language.get || (
  function(x) {
    return window.Language.strings[x] || 'Missing translation key ' + x;
  }
);

/*
 *  Query
 *    Tools used for reading/writing/manipulating the query string.
 *
 *  Dependencies:
 *
 *  Version:
 *    1.0.0 - 2018/02/12
 */

window.query = window.query || {};
window.queryTools = window.queryTools || {};

window.queryTools.decodeSearch = function(search) {
  var o = {};
  for (var aKeyValue, i = 0, aCouples = search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if(aKeyValue.length > 1) {
      o[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
  return o;
}

window.queryTools.setValue = function(name, value, updateHistory) {
  if(typeof updateHistory === typeof undefined) updateHistory = true;

  window.query[name] = value;

  if(updateHistory) {
    //Updates the query to have the new value and also updates the history object.
    var s = '?';
    var keys = Object.keys(window.query);
    for(var i = 0; i < keys.length; i++) {
      var k = keys[i];
      s += encodeURIComponent(k)+'='+encodeURIComponent(window.query[k]);
      if(i < keys.length-1) s += '&';
    }
    history.pushState(null, '', s);
  }
}


//Read the query string.
if(location.search.length) {
  window.query = window.queryTools.decodeSearch(location.search);
}

       (function(win) {
            'use strict';
            
            var listeners = [], 
            doc = win.document, 
            MutationObserver = win.MutationObserver || win.WebKitMutationObserver,
            observer;
            
            function ready(selector, fn) {
                // Store the selector and callback to be monitored
                listeners.push({
                    selector: selector,
                    fn: fn
                });
                if (!observer) {
                    // Watch for changes in the document
                    observer = new MutationObserver(check);
                    observer.observe(doc.documentElement, {
                        childList: true,
                        subtree: true
                    });
                }
                // Check if the element is currently in the DOM
                check();
            }
                
            function check() {
                // Check the DOM for elements matching a stored selector
                for (var i = 0, len = listeners.length, listener, elements; i < len; i++) {
                    listener = listeners[i];
                    // Query for elements matching the specified selector
                    elements = doc.querySelectorAll(listener.selector);
                    for (var j = 0, jLen = elements.length, element; j < jLen; j++) {
                        element = elements[j];
                        // Make sure the callback isn't invoked with the 
                        // same element more than once
                        if (!element.ready) {
                            element.ready = true;
                            // Invoke the callback with the element
                            listener.fn.call(element, element);
                        }
                    }
                }
            }

            // Expose `ready`
            win.ready = ready;
                    
        })(this);

/*================ Objects ================*/
/*
 *  Accordion
 *    Scripts for accordion sliders
 *
 *  Dependencies:
 *    jQuery - jQuery is required for event listeners
 *    styles/objects/_accordion.scss - Styles for the accordion
 *
 *  Version:
 *    1.0.0 - 2018/02/12
 */
function Accordion(container) {
  this.container = container;
  this.id = (window.accordions = window.accordions || []).length;
  this.container.attr('data-id', this.id);
  this.slides = this.container.find('[data-accordion-slide]');

  this.multiple = this.container.data('multiple') || false;

  //Asign indicies
  this.slides.each(function(e) {
    var self = $(this);
    self.attr('data-id', e);
    self.find('[data-accordion-title]').attr('data-id', e);
  });

  //Event Handlers
  this.container.on('click', '[data-accordion-title]', this.changeSlide.bind(this));
}

Accordion.prototype = {
  changeSlide: function(e, b) {
    if(this.container === typeof undefined) return;
    var self = $(e.currentTarget);
    var index = self.data('id');
    if(typeof index === typeof undefined) return;
    this.setSlide(index);
  },

  getSlideByIndex: function(index) {
    return this.container.find('[data-accordion-slide][data-id="'+index+'"]');
  },

  setSlide: function(index) {
    var slide = this.getSlideByIndex(index);

    console.log(slide);

    if(slide.attr('data-expanded') == "true") {
      //Already expanded, just shrink this one
      slide.removeClass('is-expanded');
      slide.attr('data-expanded', false);
    } else {
      if(!this.multiple) {
        this.slides.removeClass('is-expanded');
        this.slides.attr('data-expanded', false);
      }
      slide.addClass('is-expanded');
      slide.attr('data-expanded', true);
    }

    this.onExpand(index, slide);
  },

  onExpand: function(index, slide) {

  }
}

$(document).ready(function() {
  $('[data-accordion]').each(function() {
    var self = $(this);
    var accordion = new Accordion(self);
    window.accordions = window.accordions || [];
    window.accordions.push(accordion);
  });
  
  $('.c-product__mix-option').each(function() {
    var tempText = $(this).attr('data-product-mix-title');
    tempText = tempText.split('-')[1].split('(')[0].trim();
    $(this).children('.product-mix-label').text(tempText);
  });
  $('.c-product__mix-option .product-mix-remove').on('click',function(e){
//     e.stopPropagation();
    $(this).parents('.c-product__mix-option').addClass('is-removed');
    
  });
});

/*
 *  Variant Selector
 *    Provides basic functionality for the variant selector
 *
 *  Dependencies:
 *    scripts/tools/query.js
 *    scripts/tools/language.js - Required for messasges.
 *    scripts/tools/currency.js - Required for money.
 *    snippets/variant-selector.liquid
 *
 *  Version:
 *    2.0.0 - 2018/07/30
 */
window.Language.required('products.product.add_to_cart');
window.Language.required('products.product.sold_out');

//Common Functions
window.VariantSelector = window.VariantSelector || {};
window.VariantSelector.getVariantData = window.VariantSelector.getVariantData || (function(variant) {
  var data = JSON.parse( $('[data-product-json]').html() );
  //Get the variant value
  var variantData;
  for(var i = 0; i < data.variants.length; i++) {
    var v = data.variants[i];
    if(v.id != variant) continue;
    variantData = v;
    break;
  }
  return variantData;
});



//Track changes to the selector
$(document).on('change', '[data-product-select]', function(e) {
  var self = $(this);
  var variant = self.val();
  
  var variantData = window.VariantSelector.getVariantData(variant);
  if(typeof variantData === typeof undefined) return;

  $(document).trigger('onVariantChange',[variant,variantData]);
});

//Track events
$(document).on('onVariantChange', function(e, variant, variantData) {
  //Update Selectors
  $('[data-product-select]').val(variant);

  //Update the URL
  window.queryTools.setValue('variant', variant);

  //Update product details
  var price = variantData.price;
  var moneyElement = $('[data-product-money]');
  moneyElement.attr('data-money', price);
  moneyElement.html(window.Currency.formatMoney(price));
  moneyElement.trigger('onMoneyChange', price);

  //Compare at price. Please note this logic is replicated in the
  //product-pricing.liquid snippet, please ensure all logic changes made here
  //are replicated there.
  var comparePrice = variantData.compare_at_price;
  var compareMoneyElement = $('[data-product-compare-money]');
  if(comparePrice > price) {
    compareMoneyElement.attr('data-money', comparePrice);
    compareMoneyElement.html(window.Currency.formatMoney(comparePrice));
    compareMoneyElement.trigger('onMoneyChange', comparePrice);
  } else {
    compareMoneyElement.removeAttr('data-money');
    compareMoneyElement.html('');
  }

  //Update Add To Cart Button
  var addToCart = $('[data-add-to-cart]');
  if(variantData.available) {
    addToCart.removeAttr('disabled');
    addToCart.html(window.Language.get('products.product.add_to_cart'));
  } else {
    addToCart.attr('disabled', 'disabled');
    addToCart.html(window.Language.get('products.product.sold_out'));
  }
});

//History Event
window.onpopstate = function(event) {
  var t = event.target;
  var o = window.queryTools.decodeSearch(t.location.search);

  if(typeof o.variant === typeof undefined || !o.variant.length) return;
  if($('[data-product-select]').val() == o.variant) return;

  var variantData = window.VariantSelector.getVariantData(o.variant);
  if(typeof variantData === typeof undefined) return;

  $(document).trigger('onVariantChange',[o.variant,variantData]);
};

/*
 *  Quantity Selector
 *    Quantity Selector. Please note that this has no logic and is designed to
 *    be implemented by a subclass (e.g. a Product Page Quantity Selector, or
 *    a Cart Page Quantity Selector)
 *
 *  Version:
 *    1.0.0 - 2018/07/29
 */
function QuantitySelector(container) {
  this.container = container;

  //Elements
  this.addButton = container.find('[data-quantity-selector-plus]');
  this.minusButton = container.find('[data-quantity-selector-minus]');
  this.input = container.find('[data-quantity-selector-input]');

  //Listeners
  container.on('click touchstart', '[data-quantity-selector-minus]', this.onMinusClick.bind(this) );
  container.on('click touchstart', '[data-quantity-selector-plus]', this.onAddClick.bind(this) );
  container.on('blur', '[data-quantity-selector-input]', this.onBlur.bind(this));

  //Internals
  this.fixIntegers();
  this.previousValue = this.getValue();
  this.updateButtonStates();
}

QuantitySelector.prototype = {
  getValue: function() {
    var v = parseInt(this.input.val());
    if(isNaN(v)) v = 0;
    if(!isFinite(v)) v = 0;
    if(v < this.getMin()) v = this.getMin();
    if(v > this.getMax()) v = this.getMax();
    if(!isFinite(v)) v = 0;
    return v;
  },

  getMin: function() {
    return this.input.attr('data-quantity-selector-input-min') || Number.NEGATIVE_INFINITY;
  },

  getMax: function() {
    return this.input.attr('data-quantity-selector-input-max') || Number.INFINITY;
  },

  onMinusClick: function(e) {
    e.preventDefault();
    e.stopPropagation();
    this.modify(-1);
  },

  onAddClick: function(e) {
    e.preventDefault();
    e.stopPropagation();
    this.modify(1);
    console.log("adding");
  },

  onBlur: function() {
    this.fixIntegers();
    var val = this.getValue();
    this.set(val);
  },

  modify: function(amt) {
    this.fixIntegers();
    var val = this.getValue();
    val += amt;
    this.set(val);
  },

  set: function(v) {
    if(isNaN(v)) v = 0;
    if(!isFinite(v)) v = 0;
    if(v < this.getMin()) v = this.getMin();
    if(v > this.getMax()) v = this.getMax();
    if(!isFinite(v)) v = 0;

    this.input.val(v);

    //Update the button states
    this.updateButtonStates();

    //Trigger an update event?
    if(this.previousValue == v) return;

    if(v > this.previousValue) {
      this.onAdd(v);
    } else {
      this.onMinus(v);
    }
    this.onChange(v);
  },

  fixIntegers: function() {
    var v = this.getValue();
    if(parseInt(this.input.val()) != v) {
      this.input.val(v);
    }
  },

  updateButtonStates: function() {
    var v = this.getValue();
    if(v == this.getMin()) {
      this.minusButton.attr('disabled', 'disabled');
    } else {
      this.minusButton.removeAttr('disabled');
    }

    if(v == this.getMax()) {
      this.addButton.attr('disabled', 'disabled');
    } else {
      this.addButton.removeAttr('disabled');
    }
  },

  //Events (you can sub these methods)
  onAdd: function() {},
  onMinus: function() {},
  onChange: function() {}
};

/*
 *  Swatch
 *    Product Swatch Controls (does not handle standard variants)
 *
 *  Dependencies:
 *    snippets/product-swatches.liquid
 *    scripts/objects/variant-selector.js
 *    jQuery
 *
 *  Version:
 *    1.1.0 - 2015/06/18
 */
window.swatch = {
  setVariantFromSwatch: function(el, value) {
    //Triggers a standard variant change based on a swatch
    var position = el.attr('data-swatch-position');

    var currentSelection = $('[data-variant-option]:selected');

    var selector = '[data-variant-option]';

    //Ok so I was running into a problem regarding multiple levels of variants
    //And this is caused by non standard variants
    //e.g. if a product has the variants:
    // Material Cloth, Color Red
    // Material Cloth, Color Blue
    // Material Silk, Color Red
    // Material Silk, Color Green
    //It will show the color green even if the material is currently cloth, and
    //Will fail to select the variant if there's.. yada yada etc etc basically
    //we need to only show variant subs for variants of top level-ness
    var optionCount = currentSelection.attr('data-option-count');
    var target;

    for(var i = 1; i <= optionCount; i++) {
      var selectorValue;
      if(i == position) {
        //This is the value we've updated.
        selectorValue = value;
      } else {
        var existingValue = currentSelection.attr('data-option'+i);
        if(typeof existingValue === typeof undefined) continue;
        selectorValue = existingValue;
      }

      var selectorTemp = ""+selector;//Temporary "previous" storage
      selector += '[data-option'+i+'="'+selectorValue+'"]';
      //Ok now we're going to check if the variant we're after exists
      var target = $(selector);
      if(!target.length) {
        //Okay so the selector we're targetting isn't valid for the new selection
        //So that means that we have to just find the first of its kind
        selector = selectorTemp + '[data-option'+i+']:first';
        target = $(selector);
      }
    }

    //Find the variant ID based from the selection
    var targetValue = target.val();
    var targetData = window.VariantSelector.getVariantData(targetValue);
    if(typeof targetData === typeof undefined) return;
    $(document).trigger('onVariantChange',[targetValue,targetData]);

    // update form ID
    var targetForm = el.closest('[data-product-form]');
    var FormID = targetForm.find('[data-product-varient-id]').val();
    var targetFormID = targetForm.find('[data-product-varient-id]');
    targetFormID.val(targetValue);
    
    console.log( targetData );
  },

  updateAvailableSwatches: function(variant) {
    //Now decide what we're going to hide and show in terms of swatches.
    var option = $('[data-variant-option][value="'+variant+'"]');
    var optionCount = option.attr('data-option-count');
    var jsonElement = $('[data-product-json]');
    if(!jsonElement.length) return;
    var data = JSON.parse( jsonElement.html() );
    var selectedVariant;
    for(var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i];
      if(v.id != variant) continue;
      selectedVariant = v;
      $('[data-selected-variant]').attr('data-selected-variant', selectedVariant.id);
      break;
    }
    if(!selectedVariant) return;

    //Begin hiding
    $('[data-swatch]').addClass('is-hidden');
    $('[data-swatch-selector] option').attr('disabled', 'disabled');

    //Top level are always available
    $('[data-swatch][data-swatch-position="1"]').removeClass('is-hidden');
    $('[data-swatch-selector][data-swatch-position="1"] option').removeAttr('disabled');



    for(var i = 2; i <= optionCount; i++) {
      //Given the selected previous level, what options for *this* level are available?
      var prevOption = selectedVariant["option"+(i-1)];
      var allowedOptionsForThisLevel = [];
      for(var x = 0; x < data.variants.length; x++) {
        var v = data.variants[x];
        var n = v["option"+i];
        if(allowedOptionsForThisLevel.indexOf(n) !== -1) continue;
        if(v["option"+(i-1)] != prevOption) continue;
        allowedOptionsForThisLevel.push(n);
      }

      for(var x = 0; x < allowedOptionsForThisLevel.length; x++) {
        var ao = allowedOptionsForThisLevel[x];
        $('[data-swatch][data-swatch-position="'+i+'"][data-value="'+ao+'"]').removeClass('is-hidden');
        $('[data-swatch-selector][data-swatch-position="'+i+'"] [value="'+ao+'"]').removeAttr('disabled');
      }
    }
  }
};

//Swatch Listeners
$(document).on('click touchstart', '[data-swatch]', function(e) {
  var self = $(this);
  window.swatch.setVariantFromSwatch(self, self.attr('data-value'));
});

$(document).on('change', '[data-swatch-selector]', function(e) {
  var self = $(this);
  window.swatch.setVariantFromSwatch(self, self.val());
});

$(document).ready(function() {
  var currentSelection = $('[data-variant-option]:selected');
  window.swatch.updateAvailableSwatches(currentSelection.attr('value'));
});

//Variant Listeners
$(document).on('onVariantChange', function(e, variant, variantData) {
  var option = $('[data-variant-option][value="'+variant+'"]');
  var optionCount = option.attr('data-option-count');

  $('[data-swatch]').removeClass('is-selected');

  //Now decide what we're going to hide and show in terms of swatches.
  window.swatch.updateAvailableSwatches(variant);

  for(var i = 1; i <= optionCount; i++) {
    var val = option.attr('data-option'+i);
    var s = $('[data-swatch][data-swatch-position="'+i+'"][data-value="'+val+'"]');
    s.addClass('is-selected');
    $('[data-swatch-selector][data-swatch-position="'+i+'"]').val(val);

    var display = variantData['option'+i];
    if(s.attr('data-label')) display = s.attr('data-label').escapeHTML();
    $('[data-swatch-value][data-swatch-position="'+i+'"]').html(display);

  }
});

/*
 *  Product Page Quantity Selector
 *    Quantity Selector for a product page.
 *
 *  Dependencies:
 *    scripts/objects/_quantity-selector.js
 *
 *  Version:
 *    1.0.0 - 2018/07/30
 */
function ProductPageQuantitySelector(container) {
  QuantitySelector.call(this, container);
}

//Inherit
ProductPageQuantitySelector.prototype = Object.assign(Object.assign(Object.assign({}, QuantitySelector.prototype), ProductPageQuantitySelector.prototype), {
  onAdd: function() {},
  onMinus: function() {},
  onChange: function() {
  },
});

//Finalize Inheritence
ProductPageQuantitySelector.prototype.constructor = ProductPageQuantitySelector;

//TODO: Add support for max that can be added to the cart, this is limited due
//to the fact that the product JSON does not contain the max inventory (maybe a
//good idea)

//Attach
$(document).ready(function() {
  $('[data-product-quantity-selector]').each(function() {
    var self = $(this);
    new ProductPageQuantitySelector(self);
  });
});

/*
 *  Product Thumbnail
 *
 *  Version:
 *    1.0.0 - 2019/06/08
 */
function ProductThumbnailQuantitySelector(container) {
  QuantitySelector.call(this, container);
}

//Inherit
ProductThumbnailQuantitySelector.prototype = Object.assign(Object.assign(Object.assign({}, QuantitySelector.prototype), ProductThumbnailQuantitySelector.prototype), {
  onAdd: function() {},
  onMinus: function() {},
  onChange: function() {},
});

//Finalize Inheritence
ProductThumbnailQuantitySelector.prototype.constructor = ProductThumbnailQuantitySelector;

//Attach
$(document).ready(function() {
  $('[data-product-thumbnail-quantity-selector]').each(function() {
    var self = $(this);
    new ProductThumbnailQuantitySelector(self);
  });

  $(document).on('click touchend', '[data-product-thumbnail-add-to-cart]', function(e) {
    e.preventDefault();
    e.stopPropagation();

    var self = $(e.currentTarget);
    var form = self.closest('[data-product-thumbnail-form]');
    var thumbnail = form.closest('[data-product-thumbnail]');
    var productQty = form.find('[data-quantity-selector-input]').val();

    var variantId = form.find('[name="id"]').val();
    console.log("this is :"+ variantId);

    //Feedback to show we're doing stuff
    thumbnail.addClass('is-loading');
    window.Cart.add(variantId, productQty, function() {
      thumbnail.removeClass('is-loading');
      if (window.location.href.indexOf('/cart') != -1) {
        window.scrollTo(0,0);
        window.location.reload();
      } else {
        // window.location = '/cart';
        window.location.reload();
      }
      return;
    });
  });
});

/*
 *  Product Thumbnail for colection template
 *
 *  Version:
 *    1.0.0 - 2019/06/08
 */
function CollectionThumbnailQuantitySelector(container) {
  QuantitySelector.call(this, container);
}

//Inherit
CollectionThumbnailQuantitySelector.prototype = Object.assign(Object.assign(Object.assign({}, QuantitySelector.prototype), CollectionThumbnailQuantitySelector.prototype), {
  onAdd: function() {},
  onMinus: function() {},
  onChange: function() {},
});

//Finalize Inheritence
CollectionThumbnailQuantitySelector.prototype.constructor = CollectionThumbnailQuantitySelector;

//Attach
$(document).ready(function() {
  $('[data-collection-product-thumbnail-quantity-selector]').each(function() {
    var self = $(this);
    new CollectionThumbnailQuantitySelector(self);
  });

  $(document).on('click touchend', '[data-collection-product-thumbnail-add-to-cart]', function(e) {
    e.preventDefault();
    e.stopPropagation();

    var self = $(e.currentTarget);
    var form = self.closest('[data-collection-product-thumbnail-form]');
    var thumbnail = form.closest('[data-product-thumbnail]');
    var productQty = form.find('[data-quantity-selector-input]').val();

    var variantId = form.find('[name="id"]').val();
    console.log("this is :"+ variantId);
    console.log("this is QTY:"+ productQty);

    //Feedback to show we're doing stuff
    thumbnail.addClass('is-loading');
    window.Cart.add(variantId, productQty, function() {
      thumbnail.removeClass('is-loading');
    });
  });
});


/*================ Components ================*/
/*
 *  Addresses Page
 *    Scripts for Addresses Page
 *
 *  Dependencies:
 *    jQuery - jQuery is required for event listeners
 *    scripts/tools/language.js - Required for messasges.
 *  
 *
 *  Version:
 *    1.0.0 - 2018/02/21
 */
//window.Language.required('customer.addresses.delete_confirm');

// print provinces
$(document).ready(function() {
  $('[data-account-page]').each( function(){
    updateProvinces('[data-address-country]');
  });
});

$('[data-address-country]').change(function(){
  updateProvinces($(this));
});

function updateProvinces(countrySelect , provinceTarget) {
  var countryTarget = $(countrySelect);
  var option = countryTarget.find('option:selected');
  var provinces = JSON.parse(option.attr('data-provinces'));
  var formParent = countryTarget.closest('form')
  var provinceTarget = formParent.find('[data-address-province]');

  // clear options first

  provinceTarget.find('option').remove();

  console.log("select"+option.val());

  if(!provinces.length) {
    return provinceTarget.addClass('is-hidden');
  }

  // print province options
  for(var i = 0; i < provinces.length; i++) {
    var province = provinces[i];
    var value = province[0];
    var name = province[1];

    //Generating option
    provinceTarget.append('<option value="'+value+'">'+name+'</option>');
  }

  provinceTarget.removeClass('is-hidden');
};

//Address Create
$(document).on('click', '[data-address-create-toggle]', function(e) {
  e.preventDefault();
  var self = $(this);
  $('[data-address-create-form]').toggleClass('is-visible');
});

$(document).on('click', '[data-address-create-show]', function(e) {
  e.preventDefault();

  var self = $(this);
  $('[data-address-create-form]').addClass('is-visible');
});

$(document).on('click', '[data-address-create-hide]', function(e) {
  e.preventDefault();

  var self = $(this);
  $('[data-address-create-form]').removeClass('is-visible');
});

//Address Edit
$(document).on('click', '[data-address-edit-toggle]', function(e) {
  e.preventDefault();

  var self = $(this);
  if(typeof self.data('index') === typeof undefined) {
    var target = self.closest('[data-address-edit-form]');
  } else {
    var target = $('[data-address-edit-form][data-index="'+self.data('index')+'"]');
  }
  target.toggleClass('is-visible');
});

$(document).on('click', '[data-address-edit-show]', function(e) {
  e.preventDefault();

  var self = $(this);
  if(typeof self.data('index') === typeof undefined) {
    var target = self.closest('[data-address-edit-form]');
  } else {
    var target = $('[data-address-edit-form][data-index="'+self.data('index')+'"]');
  }
  target.addClass('is-visible');
});

$(document).on('click', '[data-address-edit-hide]', function(e) {
  e.preventDefault();

  var self = $(this);
  if(typeof self.data('index') === typeof undefined) {
    var target = self.closest('[data-address-edit-form]');
  } else {
    var target = $('[data-address-edit-form][data-index="'+self.data('index')+'"]');
  }
  target.removeClass('is-visible');
});

//Address Delete
$(document).on('click', '[data-address-delete]', function(e) {
  var self = $(this);
  var id = self.data('id');
  if(!id) return;
  if (confirm('Confirm deletion?')) {
    Shopify.postLink('/account/addresses/' + id, {parameters: {_method: 'delete'}});
  }
});


//Account Nav
$(document).on('click','[data-show-orders]', function(e){

  $('[data-details-sections]').hide();
  $('[data-orders-sections]').fadeIn();
  $('.c-account-page__sidebar__nav a').removeClass('current');
  $(this).addClass('current');

});
$(document).on('click','[data-show-details]', function(e){

  $('[data-orders-sections]').hide();
  $('[data-details-sections]').fadeIn();
  $('.c-account-page__sidebar__nav a').removeClass('current');
  $(this).addClass('current');

});

//Account orders
$(document).on('click','[data-order-trigger]', function(e){
  e.preventDefault();
  var orderId = $(this).data('order-trigger');
  console.log('#'+orderId);
  $('.c-account-page__section--orders-details').hide();
  $('#'+orderId).fadeIn();
});
// =require components/accounts/theme-addresses.min.js
/*
 *  Carousel setting for about section
 *
 *  Dependencies:
 *    slick - Slick is required to run the carousel itself
 *    jQuery - jQuery is required for event listeners
 *    sections/collection-carousel.liquid - Required for building the collection carousel.
 *
 *  Version:
 *    1.0.0 - 2018/01/31
 */
function AboutCarousel(container) {
  this.container = container;
  this.id = container.attr('data-id');

  //Initialize the carousel
  this.initCarousel();

  //listen for resize
  $(window).on('resize', this.onWindowResize.bind(this));
}

AboutCarousel.prototype = {
  onWindowResize: function() {
    if($(window).width() < 750) return;
    if(this.container.hasClass('slick-initialized')) return;
    this.initCarousel();
  },

  initCarousel: function() {
    this.container.slick({
      arrows: true,
      dots: false,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 999,
          settings: "unslick"
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: true
          }
        }
      ]
    });
  }
}





$(document).ready(function() {
  $('[data-about-carousel]').each(function() {
    var self = $(this);
    new AboutCarousel(self); 
  });
});

/*
 *  Blog section (Home page)
 *
 *  Dependencies:
 *    slick - Slick is required to run the carousel itself
 *    jQuery - jQuery is required for event listeners
 *    sections/collection-carousel.liquid - Required for building the collection carousel.
 *
 *  Version:
 *    1.0.0 - 2018/01/31
 */
function blogCarousel(container) {
  this.container = container;
  this.id = container.attr('data-id');

  //Initialize the carousel
  this.initCarousel();

  //listen for resize
  $(window).on('resize', this.onWindowResize.bind(this));
}

blogCarousel.prototype = {
  onWindowResize: function() {
    if($(window).width() < 750) return;
    if(this.container.hasClass('slick-initialized')) return;
    this.initCarousel();
  },

  initCarousel: function() {
    var isMixologyCarousel = this.container.attr('data-mx-aticles-carousel');
    console.log(this.container)
    console.log('isMixologyCarousel')
    console.log(isMixologyCarousel)
    if (isMixologyCarousel) {
      this.container.slick({
        arrows: true,
        dots: false,
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 2,

        mobileFirst: true,
        responsive: [
          {
            breakpoint: 999,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              arrows: false
            }
          }
        ]
      });
    } else {
      this.container.slick({
        arrows: true,
        dots: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 999,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              arrows: false
            }
          },
          {
            breakpoint: 499,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      });
        
    }
  }
}
function blogEr(container) {
  this.container = container;
  this.id = container.attr('data-id');

  //Initialize the carousel
  this.initCarousel();

  //listen for resize
  $(window).on('resize', this.onWindowResize.bind(this));
}

blogEr.prototype = {
  onWindowResize: function() {
    if($(window).width() < 750) return;
    if(this.container.hasClass('slick-initialized')) return;
    this.initCarousel();
  },

  initCarousel: function() {
    var isMixologyCarousel = this.container.attr('data-mx-aticles-carousel');
    var arrowstoshow = this.container.attr('data-arrows');
    var dotstoshow = this.container.attr('data-dots');
    var infinitetoshow = this.container.attr('data-infinite');
    var slidesToShowS = this.container.attr('data-slides-to-show');
    var slideScroll = this.container.attr('data-slides-to-scroll');
    var boolArrow = JSON.parse(arrowstoshow);
    var booldots = JSON.parse(dotstoshow);
    console.log(this.container)
    console.log('isMixologyCarousel')
    console.log(isMixologyCarousel)
    console.log("bool "+ boolArrow )
    var c = jQuery.type(boolArrow)
    console.log("bool type "+ c)
      this.container.slick({
        arrows: boolArrow,
        dots: booldots,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
        nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
        responsive: [
          {
            breakpoint: 999,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              arrows: false
            }
          },
          {
            breakpoint: 499,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      });

  }
}

function logoCarousel(container) {
  this.container = container;
  this.id = container.attr('data-id');

  //Initialize the carousel
  this.initCarousel();

  //listen for resize
  $(window).on('resize', this.onWindowResize.bind(this));
}

logoCarousel.prototype = {
  onWindowResize: function() {
    if($(window).width() < 750) return;
    if(this.container.hasClass('slick-initialized')) return;
    this.initCarousel();
  },

  initCarousel: function() {
    this.container.slick({
      arrows: false,
      dots: false,
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 2,
      mobileFirst: true,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 999,
          settings: "unslick"
        },
        {
          breakpoint: 767,
          settings: {
            arrows: true
          }
        },
        {
          breakpoint: 499,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        }
      ]
    });
  }
}





$(document).ready(function() {
  $('[data-logos-carousel]').each(function() {
    var self = $(this);
    new logoCarousel(self); 
  });

  $('[data-aticles-carousel]').each(function() {
    var self = $(this);
    new blogCarousel(self); 
  });
  $('[data-mx-aticles-carousel]').each(function() {
    var self = $(this);
    new blogCarousel(self); 
  });
  $('[data-carousel-er]').each(function() {
    var self = $(this);
    new blogEr(self); 
  });
});
/*
 *  Collection Carousel
 *    Scripts and logic for the collection carousel.
 *
 *  Dependencies:
 *    slick - Slick is required to run the carousel itself
 *    jQuery - jQuery is required for event listeners
 *    sections/collection-carousel.liquid - Required for building the collection carousel.
 *
 *  Version:
 *    1.0.0 - 2018/01/31
 */
function CollectionCarousel(container) {
  this.container = container;
  this.id = container.data('id');

  var options = {
    infinite: this.container.data('infinite') == false ? false : true,
    slidesToShow: this.container.data('slides-to-show') || 1,
    slidesToScroll: this.container.data('slides-to-scroll') || 1,
    autoplay: this.container.data('autoplay') == true,
    dots: this.container.data('dots') == true,
    arrows: this.container.data('arrows') == true,
    adapativeHeight: true,
    autoplaySpeed: this.container.data('autoplay-speed') || 5000,
    cssEase: this.container.css('animation-timing-function') || 'cubic-bezier(0.23, 1, 0.32, 1)',
    responsive: [
      {
        breakpoint: 1250,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 449,
        settings: {
          centerPadding: '0',
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false
        }
      }
    ]
  };
  this.slick = this.container.slick(options);

  window.collectionCarousels[this.id] = this;
}

CollectionCarousel.prototype = {
  remove: function() {
    this.container.remove();

  },

  setSlide: function(slide) {
    this.container.slick('slickGoTo', slide);
  }
};

window.collectionCarousels = window.collectionCarousels || {};

$(document).ready(function() {
  $('[data-collection-carousel]').each(function() {
    var self = $(this);
    if(window.collectionCarousels[self.data('id')] ) return;//Don't double up carousels
    if(self.hasClass('slick-initialized')) return;
    new CollectionCarousel(self);
  });

  $('[data-collection-carousel-with-content]').each(function() {
    var self = $(this);
    if(window.collectionCarousels[self.data('id')] ) return;//Don't double up carousels
    if(self.hasClass('slick-initialized')) return;
    self.slick({
      infinite: self.data('infinite') == false ? false : true,
      slidesToShow: self.data('slides-to-show') || 1,
      slidesToScroll: self.data('slides-to-scroll') || 1,
      autoplay: self.data('autoplay') == true,
      dots: self.data('dots') == true,
      arrows: self.data('arrows') == true,
      adapativeHeight: true,
      autoplaySpeed: self.data('autoplay-speed') || 5000,
      cssEase: self.css('animation-timing-function') || 'cubic-bezier(0.23, 1, 0.32, 1)',
      responsive: [
        {
          breakpoint: 550,
          settings: {
            centerPadding: '0',
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  });
});


//Section events
$(document).on('shopify:section:load', '.c-section__collection-carousel', function(e) {
  var id = e.detail.sectionId;
  var carousel = window.collectionCarousels[id];
  if(typeof carousel !== typeof undefined) {
    carousel.remove();
  }
  carousel = new CollectionCarousel( $('[data-collection-carousel][data-id="'+id+'"]') );
});

$(document).on('shopify:section:unload', '.c-section__collection-carousel', function(e) {
  var id = e.detail.sectionId;
  var carousel = window.collectionCarousels[id];
  if(typeof carousel === typeof undefined) return;
  carousel.remove();
});



/*
 *  Geo Location Popup
 *    Custom GeoLocation Popup Code
 *
 *  Dependencies:
 *    scripts/tools/geo.js
 *
 *  Version:
 *    1.0.0 - 2018/10/08
 */
var GEO_CACHE_COOKIE_NAME = 'GeoDataCache';
var GEO_POPUP_REMEMBER_COOKIE = 'GeoPopupRemember';

function GeoPopup(container) {

  self = this;

  this.container = container;
  this.id = container.attr('data-section-id');
  this.remember = !(!container.attr('data-remember'));

  this.heading = this.container.find('[data-geo-heading]');
  this.content = this.container.find('[data-geo-content]');
  this.goButton = this.container.find('[data-geo-go]');
  this.closeButton = this.container.find('[data-geo-close]');

  // trigger button for non AU/NZ sites to open popup
  this.triggerButton = $(document).find('[data-geo-open]');

  //Load in data
  this.data = window.GeoPopupData || [];

  this.delay = window.GeoPopupTimer * 1000;

  //Event Handlers
  this.container.on('click', '[data-geo-close]', this.onGeoClose.bind(this));
  this.container.on('click', '[data-geo-go]', this.onGeoGo.bind(this));
  $(document).on('click', '[data-geo-open]', this.openPopup.bind(this));

  var shouldFetch = true;

  //Check for ref=0 (saves cross domain double up)
  try {
    var x = window.location.search.split('&');
    if(x && x.length) x[0] = x[0].substring(1);
    for(var i = 0; i < x.length; i++) {
      var t = x[i].split('=');
      if(t[0] != 'ref') continue;
      if(t[1] != '0' && t[1] != 0) continue;
      shouldFetch = false;
      break;
    }
  } catch(e) {
    console.error(e);
  }

  //GoogleBot avoiding :fingers_crossed:
  try {
    if(navigator.userAgent.toLowerCase().indexOf('googlebot') !== -1) shouldFetch = false;
  } catch(e) {
    console.error(e);
  }

  // Always want to get Geo data, just in case
  Geo.fetchGeo(this.onGeo.bind(this));
}

GeoPopup.prototype = {

  triggerInt: function() {
      $('html').addClass('user-ip-int');
  },

  onGeo: function(geo) {
    var countryData = false;
    var hasInt = false;
    var userCountry = geo.country;
    var useInt = false;

    for(var i = 0; i < this.data.length; i++) {
      var data = this.data[i];
      var countryCodeArray = data.code.replace(/\s/g, '').split(',');
      var isCountry = false;

      for(var x = 0; x < countryCodeArray.length; x++) {
        var code = countryCodeArray[x];

        console.log('Comparing ' +code  +' with '+geo.country);

        if (code === 'INT') {
          hasInt = true;
        }

        if (code === userCountry) {
          isCountry = true;
          thisCountry = code;
          break;
        }
        // if(code != geo.country) continue;
        // isCountry = true;
        // break;
      }

      if(!isCountry) continue;

      //Is country
      countryData = data;
      break;
    }

    // If not AU or NZ, has no countryData, and hasInt, then use Int
    if ((userCountry !== 'AU' && userCountry !== 'NZ') && !countryData && !!hasInt) {
      useInt = true;
    }

    // Only have data if country matches one in the set countries
    if((!countryData)) {
      if (!!useInt) {
        this.useGeoData(false, geo);
      } else {
        return;
      }
    } else {
      if (!!useInt) {
        this.useGeoData(false, geo);
      } else {
        this.triggerInt();
        this.useGeoData(countryData, geo);
      }
    }
  },

  useGeoData: function(data, geo) {

    var url = false;

    var refDomain;

    if (!data) {
      // if data is false, then we are doing the INT version
      refDomain = window.location.origin;
    } else {
      //Determine URL
      refDomain = data.domain;
      url = data.domain;
      url = url.replace(/^(http(s)?)?(:)?(\/)?(\/)?/gim, '//');
      if(this.container.attr('data-relative')) {
        url += window.location.pathname;
        url += window.location.search;
        if(window.location.search.length) {
          url += '&ref=0';
        } else {
          url += '?ref=0';
        }
        url += window.location.hash;
      } else {
        url += '?ref=0';
      }
    }

    ///////////////////
    // Set up popup
    ///////////////////

    //Generate heading title
    var x = (window.GeoPopupHeading||"").replace(/\%country\%/gi, geo.country_name);
    x = x.escapeHTML();
    x = x.replace('\n','<br />');

    //Generate popup content
    var y = '';
    if (!url) {
      y = (window.GeoPopupMessageInt||"");
    } else {
      y = (window.GeoPopupMessage||"");
    }
    y = y.replace(/\%country\%/gi, geo.country_name);
    y = y.escapeHTML();
    y = y.replace('\n','<br />');

    var goBtnText = this.goButton.attr('data-text');
    if (goBtnText.indexOf('%country%') > -1) {
      goBtnText = goBtnText.replace('%country%', geo.country)
    };

    //Set Popup content
    if (!url) {
      this.goButton.remove();
      this.closeButton.attr('data-domain', refDomain);
    } else {
      this.goButton.attr('href', url);
      this.goButton.attr('data-domain', data.domain);
      this.goButton.html(goBtnText);
    }
    this.closeButton.attr('data-domain', data.domain);
    this.heading.html(x);
    this.content.html(y);

    // if(data.domain == window.location.hostname) return;
    //
    var remember = Cookies.get(GEO_POPUP_REMEMBER_COOKIE);
    if(this.remember && remember === refDomain) return;

    //Force Redirect?
    if(data.redirect) {
      if(typeof Shopify !== typeof undefined && Shopify.designMode === true) {
        //Theme editor, don't actually redirect!
      } else {
        window.location.href = url;
      }
    }

    //Show popups
    setTimeout(function(){
      self.openPopup();
    }, this.delay)
  },

  openPopup: function(e) {

    if(!this.container.attr('data-enable')) return;
    $('html,body').addClass('is-geo-popup-visible');
    setTimeout(function() {
      this.container.addClass('is-visible');
    }.bind(this),1);
  },


  closePopup: function() {
    this.container.removeClass('is-visible');
    setTimeout(function() {
      $('html,body').removeClass('is-geo-popup-visible');
    }, 210);
  },

  onGeoClose: function(e) {
    e.preventDefault();
    e.stopPropagation();

    this.closePopup();
    this.rememberData(this.closeButton.attr('data-domain'));
  },

  onGeoGo: function(e) {
    this.rememberData(this.goButton.attr('data-domain'));
  },

  rememberData: function(d) {
    Cookies.set(GEO_POPUP_REMEMBER_COOKIE, d);
  }
};
(function($) {
  if(typeof $ === typeof undefined) return;
  $(document).ready(function() {
    $('[data-geo-popup]').each(function(e) {
      window.GeoPopups = window.GeoPopups || [];
      window.GeoPopups.push(new GeoPopup($(this)));
    });
  });
})(jQuery);

/*
 *  Homepage Banner
 *    Smooth Jump Scroll
 *
 *  Dependencies:
 *
 *  Version:
 *    1.0.0 - 2019/05/02
 */

var SELECTOR_CONTAINER = $('[data-header-banner]');

var parentElem = $(SELECTOR_CONTAINER).closest('.shopify-section'),
    siblingElem = $(parentElem).next('.shopify-section');

$(document).on('click touchend', '[data-header-banner-scroll-down]', function(e) {
  e.stopPropagation();
  e.preventDefault()
  
  // Offset value - 20px to to allow for bottom borders
  let offsetValue = $(siblingElem).offset().top - 130;
  console.log(offsetValue);
  $('html, body').animate({
    scrollTop: offsetValue + 'px'
  }, 500, 'swing');
})
/*
 *  Instagram
 *    Scripts for Instagram feeds
 *
 *  Dependencies:
 *    jQuery - Required for selectors
 *    Instafeed.JS - Used to manage the instagram integration
 *    sections/instagram.liquid
 *
 *  Version:
 *    1.0.0 - 2018/02/05
 */

var DEFAULT_INSTAGRAM_TEMPLATE = '<div class="c-instagram__photo-container"><a href="{{link}}" target="_blank" class="c-instagram__photo">';
DEFAULT_INSTAGRAM_TEMPLATE += '<img class="lazyload" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" data-src="{{image}}" />';
DEFAULT_INSTAGRAM_TEMPLATE += '</a></div>';

var DEFAULT_INSTAGRAM_OPTIONS = {
  get: 'user',
  template: DEFAULT_INSTAGRAM_TEMPLATE,
  resolution: 'low_resolution'
}

function instagram(self) {
  if(self.hasClass('is-running')) return;
  var token = self.data('token');
  if(!token || !token.length) return;
  var spl = token.split('.');
  if(!spl.length) return;

  //Need a polyfill for Object.assign
  var newOptions = JSON.parse(JSON.stringify(DEFAULT_INSTAGRAM_OPTIONS));
  newOptions.userId = spl[0];
  newOptions.accessToken = token;
  newOptions.target = self.attr('id');
  newOptions.limit = self.data('limit') || 8;
  newOptions.after = function() {
    var ig_sl = {
      arrows: false,
      dots: false,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 999,
          settings: "unslick"
        },
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 550,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    }


    $(document).ready(function() {
      $('[data-instagram-photos]').slick(ig_sl);
    }); 

    $(window).on('resize orientationchange', function() {
      $('[data-instagram-photos]').slick('resize');
    });
  };
  var feed = new Instafeed(newOptions);
  feed.run();

  //here we pull followers and posts count
  $.ajax({
    url: 'https://api.instagram.com/v1/users/self',
    dataType: 'jsonp',
    type: 'GET',
    data: {
      access_token: token
    },
    success: function(data) {
      var follows = data['data']['counts']['followed_by'];
      var posts = data['data']['counts']['media'];
      $('[data-instagram-posts]').text(posts+' Posts');
      $('[data-instagram-followers]').text(follows+ ' Followers');
      //console.log(posts);
    },
    error: function(data) {
      console.log(data);
    }
  });
}

$(document).ready(function() {
  $('[data-instagram-feed]').each(function() {
    instagram($(this))
  })
});


//Section events
$(document).on('shopify:section:load', '.c-section__instagram', function(e) {
  var id = e.detail.sectionId;
  var feed = $('[data-instagram-feed][data-feed-id="'+id+'"]');
  instagram(feed)
});

$(document).on('shopify:section:unload', '.c-section__instagram', function(e) {
  var id = e.detail.sectionId;
  var feed = $('[data-instagram-feed][data-feed-id="'+id+'"]');
  if(!feed.hasClass('is-running')) return;
  feed.remove();
});

$(document).on('shopify:section:select', '.c-section__instagram', function(e) {
  var id = e.detail.sectionId;
});




/*
 *  Menu Drawer
 *    Scripts for drawer menus.
 *
 *  Dependencies:
 *    jQuery - jQuery is required for event listeners
 *
 *  Version:
 *    1.0.1 - 2018/01/25
 */
$(document).on('click touchend', '[data-open-menu]', function(e) {

  e.stopPropagation();
  e.preventDefault();

  var menucontainer = $('[data-menu-drawer]');

  $(document.body).addClass('is-menu-open');
  menucontainer.addClass('is-open');
  menucontainer.removeClass('is-hiding');
  $('[data-header]').addClass('is-menu-open');

  $(this).removeAttr('data-open-menu');
  $(this).attr('data-close-menu','');
});

$(document).on('click touchend', '[data-close-menu]', function(e) {

  e.stopPropagation();
  e.preventDefault();

  var menucontainer = $('[data-menu-drawer]');


  setTimeout(function() {
    this.removeClass('is-hiding');
  }.bind(menucontainer), 200);//200 = Duration of hiding animation (in milliseconds)

  $(document.body).removeClass('is-menu-open');
  menucontainer.addClass('is-hiding');
  menucontainer.removeClass('is-open');
  $('[data-header]').removeClass('is-menu-open');

  $(this).attr('data-open-menu','');
  $(this).removeAttr('data-close-menu');

  // close all submenu
  $('[data-menu-link]').removeClass('is-open');
  $('[data-menu-img-index]').removeClass('is-open');
});


$('[data-menu-link]').hover(function(){ // on mouse over
  if ($(window).width() > 999) {
    var self = $(this);
    var targetId = self.attr('data-menu-link-index');
    var targetMenu = $('[data-menu-img-index="'+targetId+'"]');


    //Close all menus
    $('[data-menu-link]').removeClass('is-open');
    $('[data-menu-img-index]').removeClass('is-open');

    self.addClass('is-open');
    targetMenu.addClass('is-open');
  }
});




// close nav drawer if click outside
$(document).mouseup(function(e)
{
  var isMenuOpen = $(document.body).hasClass('is-menu-open');
  var container = $(".c-menu--style-draw__body, [data-close-menu]");


  if(isMenuOpen && $(window).width() > 999){

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0)
    {
      e.stopPropagation();
      e.preventDefault();


      var self = $(this);
      var target = self.data('menu-target');

      var targetElement;
      if(typeof target === typeof undefined || !target) {
        //No target specified? may be referring to parent menu
        targetElement = self.closest('[data-menu-drawer]');
      } else {
        //Find menu by that name
        targetElement = $('[data-menu-name="'+target+'"]');
        if(!targetElement.is('[data-menu-drawer]')) return;
      }
      setTimeout(function() {
        this.removeClass('is-hiding');
      }.bind(targetElement), 200);//200 = Duration of hiding animation (in milliseconds)

      $(document.body).removeClass('is-menu-open');
      targetElement.addClass('is-hiding');
      targetElement.removeClass('is-open');

        $('.c-header__hamburger-button').attr('data-open-menu','');
        $('.c-header__hamburger-button').removeAttr('data-close-menu');

      //Close all menus
      $('[data-menu-drawer]').removeClass('is-open');
      $('[data-menu-link]').removeClass('is-open');
      $('[data-menu-img-index]').removeClass('is-open');

    }
  }
});

// newsleter popup script

var popup = $('[data-target-popup]');
var expiring = parseInt(popup.val('expiring')) || 7;



$(document).ready(function() {
  if(Cookies.get('hide_popup')){
    popup.hide();
    if (window.location.href.indexOf('?customer_posted=true') > 0) {
      if(Cookies.get('popup_subscribed')){
        popup.hide();
      } else {
        popup.removeAttr('style');
        $('body').on('click', '[data-close-popup]', function() {
          popup.fadeOut();
        });
        Cookies.set('popup_subscribed', 'true', { expires: expiring });
      }
    }
  } else{
    Cookies.set('hide_popup', 'true', { expires: expiring });
    popup.fadeIn(1000);
    $('body').on('click', '[data-close-popup]', function() {
        popup.fadeOut();
    });
  }
});
/*
 *  Pager Laoder
 *    for whole site
 *
 *  Dependencies:
 *    src/styles/components/_page-loader.scss
 *    src/layout/theme.liquid
 *
 *  Version:
 *    1.0.0 - 2019/05/28
 */


// $(window).load(function() {
//   $('[data-page-loader]').fadeOut();
// });
/*
 *  Search popup
 *    for header
 *
 *  Dependencies:
 *    jQuery - Required for selectors
 *    sections/header.liquid
 *
 *  Version:
 *    1.0.0 - 2019/04/30
 */


$(document).on('click touchstart', '[data-search-trigger]', function(e) {
  e.stopPropagation();
  e.preventDefault();
  $('[data-search-modal]').fadeIn();
  $('[data-search-modal] input[type="search"]').focus(); //make the field auto focus(ready to type) 
  $('body').addClass('is-open');
});

$(document).on('click touchstart', '[data-search-close]', function(e) {
  e.stopPropagation();
  e.preventDefault();
  $('[data-search-modal]').fadeOut();
  $('body').removeClass('is-open');
});
/*
 *  Carousel setting for single product section
 *
 *  Dependencies:
 *    slick - Slick is required to run the carousel itself
 *    jQuery - jQuery is required for event listeners
 *    src/sections/single-product-carousel.liquid
 *
 *  Version:
 *    1.0.0 - 2018/01/31
 */
function SingleProductCarousel(container) {
  this.container = container;
  this.id = container.attr('data-id');
  
  this.swatchImage = container.find('[data-single-swatch-image]');

  //Initialize the carousel
  this.initCarousel();

  //listen for resize
  // $(window).on('resize', this.onWindowResize.bind(this));
  $(document).on('onVariantChange', this.onVariantChange.bind(this));
}

SingleProductCarousel.prototype = {
  onVariantChange: function(e,i,variant) {
    var img = variant.featured_image;
    if(!img) return;
    img = img.src;
    if(!img) return;

    this.swatchImage.html(ImageTools.generatePicture(img));
  },

  initCarousel: function() {
    this.container.slick({
      infinite: this.container.data('infinite') == false ? false : true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: this.container.data('autoplay') == true,
      dots: this.container.data('dots') == true,
      arrows: this.container.data('arrows') == true,
      adapativeHeight: true,
      autoplaySpeed: this.container.data('autoplay-speed') || 5000,
      cssEase: this.container.css('animation-timing-function') || 'cubic-bezier(0.23, 1, 0.32, 1)',
    });
  }
}





$(document).ready(function() {
  $('[data-single-product-carousel]').each(function() {
    var self = $(this);
    new SingleProductCarousel(self); 
  });
});

/*
  Product mixed pack functionality
  - select/activate option
  - store data as line item, in a hidden field
  - validate depending on type:
    - twin pack is min 2, max 2, dif. products
    - mix pack is the same, with min 6 max 6
*/

var INPUT_ELEMENT = "[data-product-mix-option]";

function ProductMix(container) {
 this.container = container;
 this.inputFieldText = this.container.find('#product-options');
 this.inputFieldId = this.container.find('#product-options-ids');
 // this.errorMsg = this.container.closest('[data-product-page-form]').find('[data-product-mix-msg]');
 this.selectedOptions = this.container.closest('[data-product-page-form]').find('[data-product-mix-selected]');
 this.submitBtn = this.container.closest('[data-product-page-form]').find('[data-product-page-add-to-cart]');

 this.currentlySelected = 0;
 this.productCount = this.container.attr('data-product-mix-count');
 this.container.attr('data-product-mix-selected-count', this.currentlySelected);
  
 this.container.on('click', INPUT_ELEMENT, this.onClick.bind(this));
 this.container.on('click', '.product-mix-remove', this.onRemove.bind(this)); 
 this.submitBtn.on('click', this.onSubmit.bind(this));  
 // console.log(">>", this.selectedOptions);
}

ProductMix.prototype = {
  onClick: function(e) {
    // Get element
    var element = e.currentTarget;
    var elementCount = parseInt($(element).attr('data-product-mix-option-count'), 10);
    var productCount = parseInt($(element).attr('data-product-mix-option-count-max'), 10);
    var elementAvailable = $(element).attr('data-product-available');
    // If clicking self, remove class
//     if ($(element).hasClass('is-selected')) {
//       $(element).removeClass('is-selected');
//       // update the stored data
//       this.updateInputs();
//       // Update the selected count
//       this.updateCount();
//       return;
//     };
    // Check count of selected options, need to check it after if clicking self
    if (this.currentlySelected >= this.productCount) {
      return;
    };
    if (elementAvailable == "false"){
      return;
    };
    // Put class on element
    $(element).addClass('is-selected');
    $(element).attr('data-product-mix-option-count', elementCount+1);
    if (elementCount >= productCount) {
      $(element).attr('data-product-mix-option-count', productCount);
      return;
    }
    // update the stored data
    this.updateInputs();
    // Update the selected count
    this.updateCount();
  },
  onRemove: function(e) {
    // Get element
    e.stopPropagation();
    var element = $(e.currentTarget).parent();
    var elementCount = parseInt($(element).attr('data-product-mix-option-count'), 10);
    var productCount = parseInt($(element).attr('data-product-mix-option-count-max'), 10);
    if ($(element).hasClass('is-removed')) {
      //this.currentlySelected -= elementCount;
      $(element).attr('data-product-mix-option-count', 0);
      $(element).removeClass('is-selected');
      
        // update the stored data
        this.updateInputs();
        // Update the selected count
        this.updateCount();
        $(element).removeClass('is-removed');
        return;
      };
      // Check count of selected options, need to check it after if clicking self
      if (this.currentlySelected >= this.productCount) {
        return;
      };

      // Put class on element

      // update the stored data
      this.updateInputs();
      // Update the selected count
      this.updateCount();
    
  },
  updateInputs: function() {
    // Get all the selected items
    var selected = $(INPUT_ELEMENT+'.is-selected'),
        text = [],
        ids = [],
        length = 0,
        self = this;
    // Iterate over all of the selected options
    selected.each(function(index){
      // Push the data to the hidden text fields
      var tempCount = parseInt($(this).attr('data-product-mix-option-count'), 10);
      var tempText = $(this).attr('data-product-mix-title');
      tempText = tempText.split('-')[1].split('(')[0].trim();
      text.push(tempText + ' x' + tempCount);
      ids.push($(this).attr('data-product-mix-id'));
      length = length + tempCount;
    });

    text = text.join(', ');
    ids = ids.join(', ');

    // Update the input element value
    this.inputFieldText.val(text);
    this.inputFieldId.val(ids);

    // Update the selected options text
    this.updateText(text);
  },
  updateCount: function(){
    var selectedItems = $(INPUT_ELEMENT+'.is-selected').toArray();
    var selectedValues = selectedItems.map(function(item){ return parseInt($(item).attr('data-product-mix-option-count')) });
    
    this.currentlySelected = selectedValues.reduce(function(total, value) { return total + parseInt(value)});
    this.container.attr('data-product-mix-selected-count', this.currentlySelected);
    // this.errorMsg.removeClass('is-shown');
  },
  updateText: function(text){
    console.log(text);
      this.selectedOptions.html(text);
    // if (text !== '') {
    // } else {
    //   this.selectedOptions.removeClass('is-shown');
    // }
  },
  onSubmit: function(e){
    // Validate X options are selected
    // if (this.currentlySelected != this.productCount) {
    //   // this.errorMsg.addClass('is-shown');
    //   e.preventDefault();
    //   e.stopPropagation();
    // }
  }
}

$(document).ready(function() {
 $('[data-product-mix]').each(function() {
   var self = $(this);
   new ProductMix(self);
 });
});

/*
 *  Cart Template
 *
 *
 *  Dependencies:
 *    src/sections/cart-template.liquid
 *
 *  Version:
 *    1.0.0 - 2019/05/15
 */

$(document).ready(function() {

  //cart back button
  var current_location = window.location.href;
  var button_url;

  if (current_location.indexOf('/cart') != -1) {
    button_url = (Cookies.get('last_location')) ? Cookies.get('last_location') : window.location.hostname;
  } else {
    // if user is on any other page, store their location in a cookie
    Cookies.set('last_location', current_location);
  }

  $(document).on('click touchend','[data-history-back],[data-history-back-footer]', function(e){
   e.stopPropagation();
   e.preventDefault();

   window.location = button_url;
  });

  // QTY
  $(document).on('click touchend', '[data-cart-qty]', function(e) {
    e.stopPropagation();
    e.preventDefault();

    var $this = $(this);
    var $input = $this.siblings('input');
    if(!$input.length) $input =  $this.siblings('.c-product__info__purchase__qty__wrap').find('input');

    var firstloadVal = parseInt($input.attr("data-qty-value"));
    var val = parseInt($input.val());
    var valMax = 100000000000000000000000000000;
    var valMin = $input.attr('min') || 0;

   if($input.attr('max') != null){
     valMax = $input.attr('max');
   }

   if(isNaN(val) || val < valMin) {
    $input.val(valMin);
    return false;
   } else if (val > valMax) {
    $input.val(valMax);
    return false;
   }

   if($this.attr('data-func') == 'plus') {
    if(val < valMax) $input.val(val + 1);
   } else {
    if(val > valMin) $input.val(val - 1);
    if($this.parents(".cart_item").length) {
    }
   }
   $input.trigger('change');
  });
});

$(document).on('change keyup keydown', '[data-quantity-field]', function(e) {
  e.preventDefault();
  e.stopPropagation();
  
  var self = $(this);

  //show update button
  var val = parseInt(self.val());
  var initialVal = parseInt(self.attr('data-qty-value'));
  var btnUpdate = self.parents('.c-template-cart__product-qty').siblings('[data-cart-qty-update]');

  if(val != initialVal){
    btnUpdate.addClass('is-visible');
  } else {
    btnUpdate.removeClass('is-visible');
  }
});

/*
 *  Collection Template
 *
 *
 *  Dependencies:
 *    scripts/components/AjaxCollection.js
 *
 *  Version:
 *    1.0.0 - 2018/07/20
 */

$(document).ready(function() {
  // show all subcol on page load
  $('[data-sub-collection]').addClass('is-showing');
});

// toggle filter nav
$(document).on('click touchend', '[data-fillter-toggle-button]', function(e) {
  e.stopPropagation();
  e.preventDefault();
  
  $( "[data-fillter-toggle]" ).toggleClass('is-showing');
  $('[data-fillter-toggle-button-open]').toggleClass('is-hidden');
  $('[data-fillter-toggle-button-close]').toggleClass('is-hidden');
});


$(document).on('click touchend', '[data-fillter-button]', function(e) {

  e.stopPropagation();
  e.preventDefault();

  var self = $(e.currentTarget);
  var targetID = self.attr('data-fillter-target');
  var targentSubcol = $('[data-sub-collection-id='+targetID+']');

  // // clear displaying
  $('[data-fillter-button-all]').removeClass('is-active');
  $('[data-fillter-button]').removeClass('is-active');
  $('[data-sub-collection]').removeClass('is-active');
  $('[data-sub-collection]').removeClass('is-showing');

  // // add class show product
  self.addClass('is-active');
  targentSubcol.addClass('is-active');
});


// show all
$(document).on('click touchend', '[data-fillter-button-all]', function(e) {

  e.stopPropagation();
  e.preventDefault();

  var self = $(e.currentTarget);
  var targetID = self.attr('data-fillter-target');
  var targentSubcol = $('[data-sub-collection-id='+targetID+']');

  // // clear displaying
  $('[data-fillter-button-all]').removeClass('is-active');
  $('[data-fillter-button]').removeClass('is-active');
  $('[data-sub-collection]').removeClass('is-active');

  // // add class show product
  self.addClass('is-active');
  $('[data-sub-collection]').addClass('is-showing');
});
/*
 *  Collection Kombucha
 *
 *
 *  Dependencies:
 *    src/sections/collection-template-kombucha.liquid
 *    slick - Slick is required to run the carousel itself
 *    jQuery - jQuery is required for event listeners
 *    sections/collection-carousel.liquid - Required for building the collection carousel.
 *
 *  Version:
 *    1.0.0 - 2019/05/16
 */


function KombuchaCarousel(container) {
  this.container = container;
  this.id = container.attr('data-id');

  //Initialize the carousel
  this.initCarousel();

  //listen for resize
  $(window).on('resize', this.onWindowResize.bind(this));
}

KombuchaCarousel.prototype = {
  onWindowResize: function() {
    if($(window).width() < 750) return;
    if(this.container.hasClass('slick-initialized')) return;
    this.initCarousel();
  },

  initCarousel: function() {
    this.container.slick({
      arrows: false,
      dots: false,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 999,
          settings: "unslick"
        },
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 499,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    });
  }
}





$(document).ready(function() {
  $('[data-collection-show-product-carousel]').each(function() {
    var self = $(this);
    new KombuchaCarousel(self); 

    // check if safari
    var userAgent = navigator.userAgent.toLowerCase(); 
    if (userAgent .indexOf('safari')!=-1){ 
      if(userAgent .indexOf('chrome')  > -1){
        //browser is chrome
        $('body').addClass("browser-chrome");
      }else{
       //browser is safari, add css
       $('body').addClass("browser-safari");
      }
     }
  });
});


$(document).on('click touchscreen', '[data-product-thumbnail-show-product]', function(e) {

  e.stopPropagation();
  e.preventDefault()

  var self = $(e.currentTarget);
  var targetID = self.attr('data-product-thumbnail-show-product-id');
  var targentProduct = $('[data-collection-product-show='+targetID+']');

  if (!self.hasClass('is-showing')) {
    // clear other product
    $('[data-collection-product-show]').removeClass('is-showing');
    $('[data-product-thumbnail-show-product]').removeClass('is-showing');

    // add class show product
    self.addClass('is-showing');
    targentProduct.addClass('is-showing');

    // jump to the next section
    var parentElem = self.closest('.shopify-section'),
      siblingElem = parentElem.next('.shopify-section');
    // Offset value - 20px to to allow for bottom borders
    let offsetValue = $(siblingElem).offset().top;
    $('html, body').animate({
      scrollTop: offsetValue + 'px'
    }, 500, 'swing');
    return;
  }
  $('[data-collection-product-show]').removeClass('is-showing');
  $('[data-product-thumbnail-show-product]').removeClass('is-showing');

});
/*
 *  Product Template
 *    Contains logic for the product template.
 *
 *  Dependencies:
 *    scripts/objects/_variant-selector.js
 *    scripts/objects/cart.js
 *
 *  Version:
 *    1.0.0 - 2018/07/30
 */


function ProductTemplate(container) {
  this.container = container;

  this.variantSelector = this.container.find('[name="id"]');
  this.qtySelector = this.container.find('[name="quantity"]');
  this.addToCartButton = this.container.find('[data-product-page-add-to-cart]');
  this.cartIcon = $('.c-header__icon-cart');
  this.cartCounter = $('[data-cart-counter]');
  this.addToCartButtonText = this.container.find('[data-product-page-add-to-cart]').first().text();
  this.completeDescription = $('[data-product-description]');

  this.swatchImage = container.find('[data-single-swatch-image]');



  //qty selector
  this.quantitySelector = new QuantitySelector(container.find('[data-product-quantity-selector]'));


  this.container.on('click', '[data-product-page-add-to-cart]', this.onAddToCart.bind(this));
  this.container.on('click', '[data-accordion-trigger]', this.onChangeTabs.bind(this));
  this.container.on('click', '[data-read-more-product]', this.onReadMore.bind(this));

  $(document).on('onCartPending', this.onCartPending.bind(this));
  $(document).on('onCartFinished', this.onCartFinished.bind(this));
  $(document).on('onCartUpdate', this.onCartUpdate.bind(this));
  $(document).on('onVariantChange', this.onVariantChange.bind(this));
}

ProductTemplate.prototype = Object.assign(ProductTemplate.prototype, {
  onVariantChange: function(e,i,variant) {
    var img = variant.featured_image;
    if(!img) return;
    img = img.src;
    if(!img) return;

    this.swatchImage.html(ImageTools.generatePicture(img));
  },

  onAddToCart: function(e) {
    e.preventDefault();
    e.stopPropagation();
    var id = this.variantSelector.val();
    if(this.variantSelector && this.variantSelector.length > 1) {
      id = $(e.currentTarget).parents('form').find('[name=id]').val();
    }
    var qty = this.qtySelector.val();
    var props = {};
    this.container.find('[name^=properties]').each(function(i, e) {
      var self = $(e);
      var name = self.attr('name');
      if(name.indexOf('[') === -1 || name.indexOf(']') === -1) return;
      name = name.split('[')[1].split(']')[0];
      props[name] = self.val();
    });
    window.Cart.add(id, qty, function(){}, props);
  },


  onCartUpdate: function(e, newCart) {
    this.cartIcon.addClass('rotate');
    this.addToCartButton.text('Added!');
    setTimeout(function(){
      this.addToCartButton.html('<span>'+this.addToCartButtonText+'</span>');
    }.bind(this),3000);
  },

  onCartPending: function(e) {
    this.addToCartButton.attr('disabled', 'disabled');

  },

  onCartFinished: function(e) {
    this.addToCartButton.removeAttr('disabled');
    this.cartCounter.show();
    $.ajax({
      type: 'GET',
      url: '/cart.json',
      dataType: 'json',
      success: function(result) {

        $('[data-cart-counter]').text(result.item_count);

      },
      error: function(status) {
        console.warn('ERROR', status);
      }
    });

    $('[data-product-upsell-popup]').addClass('is-visible');

  },

  onChangeTabs: function(e){
    e.preventDefault();
    e.stopPropagation();

    var target = $(e.currentTarget);
    var currentNumber = target.attr('data-accordion-trigger');

    $('[data-accordion-trigger]').removeClass('selected');
    target.addClass('selected');
    $('[data-accordion]').hide();
    $('[data-accordion="'+currentNumber+'"]').show();
  },

  onReadMore: function(e){
    this.completeDescription.html($('[data-product-description-full]').html());
  }
});

$(document).ready(function() {
  $('[data-product-page]').each(function(e, i) {
    window.productTemplate = new ProductTemplate($(this));
  });


   ready('#bookmarkit', function(element) {
    if (window.innerWidth < 750) {
      $("#smartwishlist").appendTo("[data-wishlist-mobile]");
    }
   });
});


//Clean variant name for Delivery
if ($('[data-swatch-selector]').length > 0) {
  var delivery = $('[data-swatch-selector]').val();
}

/*
 *  Video Background
 *    Waiting for video to load then fade it in so things look nice
 *
 *  Version:
 *    1.0.0 - 2019/04/12
 */


$(window).on('load', function() {
  $("[data-video-bg-video]").each(function(){
    $(this).closest('.c-video-bg').addClass("is-loaded");
  });
});

/*
 *  Login Form
 *    Scripts for login form
 *
 *  Dependencies:
 *    jQuery - jQuery is required for event listeners
 *
 *  Version:
 *    1.0.0 - 2018/02/21
 */

//Handle "Forgot your password" click
$(document).on('click', '[data-login-form-forgot-password]', function(e) {
  $('[data-login-form]').addClass('is-hidden');
  $('[data-registration-form]').addClass('is-visible');
});

$(document).on('click', '[data-login-form-cancel-forgot-password]', function(e) {
  $('[data-login-form]').removeClass('is-hidden');
  $('[data-registration-form]').removeClass('is-visible');
})


// Hide Header on on scroll down
var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('.c-section__header').outerHeight();

$(window).scroll(function(event){
    didScroll = true;
});

setInterval(function() {
    if (didScroll) {
        hasScrolled();
        didScroll = false;
    }
}, 250);

function hasScrolled() {
  var st = $(this).scrollTop();
  
  if(Math.abs(lastScrollTop - st) <= delta)
      return;

  // if (st > lastScrollTop && st > navbarHeight){
  //     // Scroll Down
  //     $('.c-section__header').removeClass('nav-down').addClass('nav-up');
  // } else {
  //     // Scroll Up
  //     if(st + $(window).height() < $(document).height()) {
  //         $('.c-section__header').removeClass('nav-up').addClass('nav-down');
  //     }
  // }
  
  lastScrollTop = st;
}
